'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './property-edit.routes';

export class PropertyEditComponent {
  constructor(Auth, $state, $stateParams, dialogs, PropertyService, $uibModal, SettingsService, ContactService) {
    'ngInject';

    this.propertyId = $stateParams.id;
    this.states = [ "AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FM", "FL", "GA", "GU", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MH", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "MP", "OH", "OK", "OR", "PW", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VI", "VA", "WA", "WV", "WI", "WY" ];

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.PropertyService = PropertyService;
    this.SettingsService = SettingsService;
    this.ContactService = ContactService;
    this.Auth = Auth;
    this.$uibModal = $uibModal;

    this.schema = {};
    this.owners = [];

    this.jsonValue = "";
    this.$state = $state;

    this.model = {
      address: {},
      customFields: {},
      eVoting: {}
    };

    this.customFields = {};

    this.form = ["*"];

    this.SettingsService.getByName({name: 'custom-fields'}, customFieldSettings => {
      if (customFieldSettings.data.hasOwnProperty("property")) {
        this.customSchema = customFieldSettings.data.property;
        this.customForm = ["*"];
      }
    });

    SettingsService.getByName({name: 'config.app'}, settings => {
      let ssDT = settings.data.serverSideDT || {};
      this.serverSideDT = ssDT && ssDT.contacts && ssDT.contacts.enabled;

      SettingsService.getByName({name: 'client'}, settings => {
        let schemaName = (settings.data.weightVisible) ? "evoting" : "evoting-no-weight";
        this.eVotingSchema = require('../../../components/schemas/' + schemaName + ".json");

        if (this.serverSideDT)
          this.eVotingSchema.properties.voter["x-schema-form"].type = "entitylookup-nodropdown"; // for SS contact lookup

        this.eVotingSchema.properties.votingCertificate.fnOpenAssetUploadModal = (key) => {
          this.openAssetUploadModal(key);
        };

        if (!this.serverSideDT) {
          ContactService.query(data => {
            this.eVotingSchema.properties.voter.entityLookupData = data.map(entity => {
              return {
                value: entity._id,
                name: this.getComposedName(entity),
                group: "Contacts"
              }
            });
          });
        }

        this.eVotingSchema.properties.voter.fnLookup = (key) => {
          this.contactLookup(key);
        };

        if (this.propertyId) {
          this.PropertyService.get({id: this.propertyId}, data => {
            this.model = data;

            if (this.serverSideDT) {
              this.eVotingSchema.properties.voter.entityLookupData = [];

              if (this.model.eVoting.voter) {
                ContactService.get({id: this.model.eVoting.voter}, data => {
                  this.eVotingSchema.properties.voter.entityLookupData.push({
                    value: data._id,
                    name: this.getComposedName(data),
                    group: "Contacts"
                  });
                });
              }
            }

            this.customFields = this.model.customFields || {};
          }, err => {
            console.log('Could not load property from server');
          })
        } else {
          if (this.serverSideDT)
            this.eVotingSchema.properties.voter.entityLookupData = [];
        }
      });

    });
  }

  contactLookup(key) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: (that.serverSideDT) ? 'contactLookupSs' : 'contactLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (contact) {
        that.model.eVoting[key] = contact._id;

        if (that.serverSideDT) {
          that.eVotingSchema.properties.voter.entityLookupData.push({
            value: contact._id,
            name: that.getComposedName(contact),
            group: "Contacts"
          });
        }
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal(key) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        if (result && result.length > 0) {
          that.model.eVoting[key] = result[0];

          //that.getAttachmentFilename();
        }

      },
      function () { /* cancel */ }
    );

  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var actionString = (this.propertyId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The property has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("property-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.model.customFields = this.customFields || {};

      if (this.propertyId) {  // Save changes on the current settings
        this.PropertyService.update({id: this.propertyId}, this.model, onSuccess, onError);
      } else { // Create new settings
        this.model.meta = {creationUser: this.Auth.getCurrentUserSync()._id};
        this.PropertyService.save(this.model, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.propertyEdit', [uiRouter])
  .config(routes)
  .component('propertyEdit', {
    template: require('./property-edit.html'),
    controller: PropertyEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/property-edit/property-edit.component.js